import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import AppButton from '../../../../components/app-button';
import RegisterHeader from '../../../../components/headers/register-header';
import Header1 from '../../../../components/headers/header1';
import Header2 from '../../../../components/headers/header2';
import { Column, Row } from '../../../../components/layout';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import { strings } from '../../../../util/strings';
import { addToWizard } from '../../../../store/actions';
import './styles.scss';

interface AlternativeContactProps {
  labels: typeof strings.pt.register;
  registoCMDLables: typeof strings.pt.registoCMD;
  globalStyles: any;
  wizard?: any;
  addToWizard?: (value: any) => void;
}

function AlternativeContact({
  labels,
  registoCMDLables,
  globalStyles,
  wizard,
  addToWizard,
}: AlternativeContactProps) {
  const history = useHistory();
  const primaryColor = globalStyles?.primaryColor || colors.blue;

  const handleCMD = () => {
    if (registoCMDLables?.registoCMD_cmdRegisterUrl) {
      window.location.href = registoCMDLables.registoCMD_cmdRegisterUrl;
    }
  };

  const handleInsurance = () => {
    if (addToWizard) {
      addToWizard({
        ...wizard,
        validationMethod: 'INSURANCE_CARD',
      });
    }
    history.push('/registo/numero-cartao');
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-container" style={{ alignItems: 'center' }}>
        <Row
          className="register-header-row"
          style={{ justifyContent: 'center', marginTop: '2.5rem' }}
        >
          <Header1
            style={{
              ...fonts.XL,
              ...fonts.Bold,
              color: colors.black,
              textAlign: 'center',
            }}
          >
            {labels?.register_other_validation_title || strings.pt.register.register_other_validation_title}
          </Header1>
        </Row>

        <Column
          className="register-existing-user-text"
          style={{
            ...fonts.ML,
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '380px',
            width: '100%',
          }}
        >
          <Header2
            style={{
              ...fonts.M,
              marginBottom: '2.5rem',
              textAlign: 'center',
              color: colors.darkGrey,
              lineHeight: '1.4',
            }}
          >
            {labels?.register_other_validation_description || strings.pt.register.register_other_validation_description}
          </Header2>

          <AppButton
            onClick={handleCMD}
            style={{
              ...fonts.M,
              ...fonts.Bold,
              width: '100%',
              maxWidth: '350px',
              borderRadius: '25px',
              height: '50px',
              backgroundColor: primaryColor,
              color: colors.white,
              cursor: 'pointer',
            }}
          >
            {labels?.register_other_validation_cmd_button || strings.pt.register.register_other_validation_cmd_button}
          </AppButton>

          <Row
            style={{
              marginTop: '2rem',
              marginBottom: '2rem',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <div style={{ flex: 1, height: '1px', backgroundColor: colors.placeholderGrey }} />
            <span style={{ margin: '0 10px', ...fonts.S, color: colors.darkGrey }}>
              {labels?.register_phone_activation_or}
            </span>
            <div style={{ flex: 1, height: '1px', backgroundColor: colors.placeholderGrey }} />
          </Row>

          <AppButton
            onClick={handleInsurance}
            style={{
              ...fonts.M,
              ...fonts.Bold,
              width: '100%',
              maxWidth: '350px',
              borderRadius: '25px',
              height: '50px',
              backgroundColor: colors.white,
              border: `1px solid ${primaryColor}`,
              color: primaryColor,
              cursor: 'pointer',
            }}
          >
            {labels?.register_other_validation_card_button || strings.pt.register.register_other_validation_card_button}
          </AppButton>
        </Column>
      </Column>
    </Column>
  );
}

const mapStateToProps = ({ stringsDefault, globalStyles, wizard }: any) => ({
  labels: stringsDefault.value.pt.register,
  registoCMDLables: stringsDefault.value.pt.registoCMD,
  globalStyles: globalStyles.value,
  wizard: wizard?.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(AlternativeContact);
